import React, { useState } from 'react';
import KFactorCalc from '../components/kfactors/KFactorCalc';
import KCharts from '../components/kfactors/KCharts';
import './KFactors.css';
import PageShell from '../components/layout/PageShell';

type ViewType = 'k-factor' | 'charts' | null;

const KFactors: React.FC = () => {
  const [activeView, setActiveView] = useState<ViewType>('k-factor');

  const handleNavClick = (view: ViewType): void => {
    setActiveView(prev => (prev === view ? null : view));
  };

  return (
    <PageShell>

      <div className="nav-bar">
        <div
          className={`nav-item ${activeView === 'k-factor' ? 'active' : ''}`}
          onClick={() => handleNavClick('k-factor')}
        >
          K-Factor
        </div>
        <div
          className={`nav-item ${activeView === 'charts' ? 'active' : ''}`}
          onClick={() => handleNavClick('charts')}
        >
          Charts
        </div>
      </div>

      <div className="view-stack">
        <div className={`view-pane ${activeView === 'k-factor' ? 'is-active' : ''}`}>
          <div className="content-container">
            <button className="close-button" onClick={() => setActiveView(null)}>×</button>
            <KFactorCalc />
          </div>
        </div>
        <div className={`view-pane ${activeView === 'charts' ? 'is-active' : ''}`}>
          <div className="content-container">
            <button className="close-button" onClick={() => setActiveView(null)}>×</button>
            <KCharts />
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default KFactors;
